import { Form } from 'components/Wizards/Form/Form'
import { Formik } from 'formik'
import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import Styles from './PurposeAndGoals.module.scss'
import { Field as BaseField } from 'components/Wizards/Field/Field'
import { Button } from 'blaze-ui/Button/Button'
import { useModals } from 'almanac-ui/Modal'
import { ArrowRight, ArrowSkip } from 'blaze-ui/icons'
import { DesktopTopic } from './DesktopTopic'
import { BrandKitWidgetInput } from 'components/Wizards/Wizard/Form/BrandKitWidgetInput'
import { Heading } from 'blaze-ui/Heading/Heading'
import { MultiStepWizard } from 'components/Wizards/MultiStepWizard'
import { multiStepSchemas } from 'components/Wizards/schemas/multiStepSchemas'
import { ConditionalInlineLanguageInputField as InlineLanguageInputField } from '../../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

interface Props extends StepProps {
  setFieldsCompleted: (val: boolean) => void
}

export const PurposeAndGoals = multiStep<Props>(
  ({ schema, initialValues, onSubmit, setFieldsCompleted, initialFormStatus }) => {
    const { closeModal, openModal } = useModals()
    const {
      fields,
      meta: { submitLabel, header, textPostEntrypoint },
    } = schema.describe()

    const fieldsWithName = (names: string[]) => Object.entries(schema.fields).filter(([name]) => names.includes(name))
    const topicField = fieldsWithName(['topic'])[0]

    const topicHidden = (fields as Record<string, any>).topic?.meta?.hide

    return (
      <Formik
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
        enableReinitialize
      >
        {({ isSubmitting, submitForm }) => {
          return (
            <Form.Root>
              <Form.Section>
                <Form.SectionContent>
                  <Form.Fields className={Styles.formFields}>
                    <Heading level={2}> {header}</Heading>
                    {topicField && !topicHidden && (
                      <DesktopTopic topicSchema={topicField[1]} textPostEntrypoint={textPostEntrypoint} />
                    )}

                    {topicHidden && (
                      <BaseField
                        name="design_wizard_fields"
                        label="Select a Brand Kit so we can generate a better caption for you"
                        direction="column"
                      >
                        <BrandKitWidgetInput />
                      </BaseField>
                    )}
                  </Form.Fields>
                </Form.SectionContent>
              </Form.Section>

              <Form.Actions isSticky>
                <Form.PrimaryActions>
                  <ResponsiveDesign.Desktop>
                    {textPostEntrypoint ? (
                      <Button
                        variant="tertiary"
                        onPress={() => {
                          const newSchema = multiStepSchemas[textPostEntrypoint]
                          closeModal()
                          if (newSchema) {
                            openModal(MultiStepWizard, { schema: newSchema, initialValues, initialFormStatus })
                          }
                        }}
                        frontIcon={ArrowSkip}
                        size="lg"
                        isDisabled={isSubmitting}
                      >
                        I just need a text post
                      </Button>
                    ) : (
                      <InlineLanguageInputField />
                    )}
                  </ResponsiveDesign.Desktop>

                  <Button
                    size="lg"
                    type="submit"
                    isDisabled={isSubmitting}
                    endIcon={ArrowRight}
                    onPress={() => {
                      submitForm()
                      setFieldsCompleted(false)
                    }}
                  >
                    {submitLabel}
                  </Button>
                </Form.PrimaryActions>
              </Form.Actions>
            </Form.Root>
          )
        }}
      </Formik>
    )
  },
)
